<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="top-area">
				<div class="reback"><a class="color-1a" href="javascript:window.history.go(-1);"> 返回
						<a-icon type="rollback" />
					</a></div>
				<div class="road-info">
					<img class="thumb" :src="imgPath+info.pcImageUrl" alt="">
					<div class="info-box">
						<div class="title-box">
							<span class="title">{{info.roadshowTitle}}</span>
							<div class="tips" v-if="status==0">预约中</div>
							<div class="tips-end" v-if="status==-1">已结束</div>
							<div class="tips" v-if="status==1">进行中</div>
						</div>
						<div class="descs">
							{{info.content||''}}
						</div>
						<div class="time">
							<div class="icon"><img src="@/assets/road_time.png" alt=""></div>
							<div class="time-info">
								<div class='color-999'>直播时间</div>
								<div class="color-1a margin-top-10">{{info.beginTime}}—{{info.endTime}}</div>
							</div>
						</div>
						<div class="company">
							<div class="icon"><img src="@/assets/road_danwei.png" alt=""></div>
							<div class="company-info">
								<div class='color-999'>主办单位</div>
								<div class="color-1a margin-top-10">{{info.organizer}}</div>
							</div>
						</div>
						<div class="anchor">
							<a class="baoming" v-if="info.lookbackLinkurl!='' && status==-1"
								:href="info.lookbackLinkurl" target="_blank">查看回放</a>
							<a class="baoming" v-if="info.lookbackLinkurl!='' && info.isSignup==1 && status!=-1"
								@click="modal = true">报名</a>
							<a class="live" v-if="info.lineLinkurl!=''&& status!=-1" :href="info.lineLinkurl"
								target="_blank">进入直播间</a>
						</div>
					</div>
				</div>
			</div>

			<div class="card margin-bottom-30">
				<div class="card-head">
					<div class="title">
						<div class="line"></div>详情介绍
					</div>
				</div>
				<div class="card-body">
					<div class="margin-top-30" v-html="info.details"></div>
				</div>
			</div>
			<a-modal v-model:visible="modal" title="报名" okText="提交" cancelText="取消" @ok="handleOk">
				<div class="margin-bottom-15">
					<div>公司名称</div>
					<div>
						<a-input v-model:value="form.company" placeholder="请输入公司名称" />
					</div>
				</div>
				<div class="margin-bottom-15">
					<div>职位</div>
					<div>
						<a-input v-model:value="form.job" placeholder="请输入职位" />
					</div>
				</div>
				<div class="margin-bottom-15">
					<div>姓名</div>
					<div>
						<a-input v-model:value="form.name" placeholder="请输入姓名" />
					</div>
				</div>
				<div class="margin-bottom-15">
					<div>手机号</div>
					<div>
						<a-input v-model:value="form.phone" placeholder="请输入手机号" />
					</div>
				</div>
				<div>
					<div>验证码</div>
					<div>
						<a-input-group compact>
							<a-input v-model:value="form.vcode" placeholder="请输入手机验证码" style="width: calc(100% - 105px)" />
							<a-button @click="showCode" type="primary" :disabled="btnDisable">{{timeStr}}</a-button>
						</a-input-group>
					</div>
				</div>
				<div><Vcode style="z-index:99999;" :show="isShow" @success="codeSuccess" @close="codeClose" /></div>
			</a-modal>
			<!-- 	<div class="card margin-bottom-30">
				<div class="card-head">
					<div class="title">
						<div class="line"></div>其他
					</div>
				</div>
				<div class="card-body">
					
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Vcode from "vue-puzzle-vcode";
	export default {
		components:{
			Vcode
		},
		data() {
			return {
				headBg: "",
				imgPath: "",
				menuPosition: "",
				id: "",
				info: "",
				status: -2,
				modal: false,
				isShow:false,
				time:60,
				btnDisable:false,
				timeStr:"获取验证码",
				form: {
					company: "",
					job: "",
					name: "",
					phone: "",
					vcode: "",
				}
			}
		},
		mounted() {
			document.title = "雄安股权交易所-培训路演";
			this.imgPath = this.$api.baseUrl + this.$api.imgPath;
			this.menuPosition = this.$route.query.menuPosition;
			this.id = this.$route.query.roadshow;
			this.getHeadBanner();
			this.getDetails();
		},
		methods: {
			handleOk() {
				if(this.form.company==""){
					this.$message.error("请输入公司名称");
					return false;
				}
				if(this.form.job==""){
					this.$message.error("请输入职位");
					return false;
				}
				if(this.form.name==""){
					this.$message.error("请输入姓名");
					return false;
				}
				if(this.form.phone==""){
					this.$message.error("请输入手机号");
					return false;
				}
				if(this.form.vcode==""){
					this.$message.error("请输入验证码");
					return false;
				}
				
				this.$request({
					url:this.$api.roadshow.roadshowSign,
					data:{
						companyName:this.form.company,
						name:this.form.name,
						phone:this.form.phone,
						position:this.form.job,
						roadshowId:this.id,
						smsCode:this.form.vcode,
					},
				}).then((res)=>{
					if(res.data.success){
						this.$message.success("报名成功");
						this.modal = false;
					}else{
						this.$message.error('报名失败');
					}
				})
			},
			codeSuccess(msg){
				this.isShow = false;
				this.timeTick();
			},
			codeClose(){
				this.isShow = false;
			},
			showCode(){
				if(this.form.phone==""){
					this.$message.error("请输入手机号");
					return false;
				}
				this.isShow = true;
			},
			timeTick(){
				let time = this.time;
				this.btnDisable = true;
				
				this.$request({
					url:this.$api.roadshow.sendPhone,
					data:{phone:this.form.phone},
				}).then((res)=>{
					if(res.data.success){
						this.$message.success("发送验证码成功");
						let tick = setInterval(()=>{
							time--;
							this.timeStr = time+"秒后获取";
							if(time<=0){
								this.btnDisable = false;
								this.timeStr = "获取验证码";
							}
						},1000);
					}else{
						this.$message.error('发送验证码失败');
					}
				})
				
				
			},
			getDetails() {
				this.$request({
					url: this.$api.roadshow.queryById,
					data: {
						id: this.id
					}
				}).then((res) => {
					this.info = res.data.result;
					this.checkStatus(this.info.beginTime, this.info.endTime);
				})
			},
			//检查状态
			checkStatus(begin, end) {
				let beginDate = new Date(begin);
				let endDate = new Date(end);
				let now = new Date();
				if (now < beginDate) {
					this.status = 0;
				} else if (now >= beginDate && now < endDate) {
					this.status = 1;
				} else {
					this.status = -1;
				}
			},
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
		}
	}
</script>

<style scoped>
	.top-area {
		background-color: white;
		padding: 20px;
		border-radius: 8px;
		margin-top: -50px;
		position: relative;
	}

	.top-area .reback {
		position: absolute;
		top: 25px;
		right: 30px;
		font-size: 16px;
	}

	.card {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		margin-top: 30px;
	}

	.card .card-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.card .card-head .line {
		width: 4px;
		height: 24px;
		margin-right: 10px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
	}

	.card .card-head .title {
		color: #1A1A1A;
		font-size: 24px;
		font-weight: 500;
		display: flex;
		align-items: center;
	}

	.road-info {
		display: flex;
		margin-top: 33px;
		border: 1px solid #E6E6E6;
	}

	.road-info .thumb {
		width: 600px;
		height: 361px;
		object-fit: cover;
	}

	.road-info .info-box {
		padding: 40px;
		/* width:60px; */
		position: relative;
	}

	.road-info .anchor {
		position: absolute;
		bottom: 30px;
		width: 440px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.road-info .info-box .title-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.road-info .info-box .title-box .title {
		font-size: 24px;
		font-weight: 500;
		color: #1A1A1A;
	}

	.road-info .info-box .title-box .tips {
		width: 60px;
		height: 24px;
		background: #13B8EE;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #13B8EE;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.road-info .info-box .title-box .tips-end {
		width: 60px;
		height: 24px;
		background: #999;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #999;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}


	.road-info .info-box .descs {
		color: #666666;
		margin-top: 24px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.road-info .info-box .time {
		margin-top: 32px;
		display: flex;
		align-items: center;
	}

	.road-info .info-box .time .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}

	.road-info .info-box .time .time-info {
		margin-left: 10px;
	}

	.road-info .info-box .company {
		margin-top: 16px;
		display: flex;
		align-items: center;
	}

	.road-info .info-box .company .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}

	.road-info .info-box .company .company-info {
		margin-left: 10px;
	}


	.anchor .baoming {
		width: 200px;
		height: 50px;
		background: #13B8EE;
		border-radius: 8px 8px 8px 8px;
		font-size: 18px;
		color: white;
		line-height: 50px;
		text-align: center;
		border: none;
		cursor: pointer;
	}

	.anchor .baoming:active {
		opacity: 0.8;
	}

	.anchor .live {
		width: 200px;
		height: 50px;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid #999999;
		font-size: 18px;
		line-height: 50px;
		color: #999999;
		text-align: center;
		cursor: pointer;
	}

	.anchor .live:active {
		opacity: 0.8;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/roadshow/info.vue